import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../../App/ModalCamposObligatorios'
import ModalDetalleMarcas from './ModalDetalleMarcas';
import { setModoVerDetalleFC_08 } from '../../../../redux/DucksAtencionACliente/FC_08AtencionAClienteDucks';
function TablaMarcas(props) {

    const { api = undefined } = props
    let fc_36MarcasMap = props.productosMap
    let otrainstalacion = props.propia
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdle, handdleRemovePrev, handdleEditPrev, marcas, handdleMarcasBaja/*, handdleMarcasAlta*/ } = api
    const [id, setId] = React.useState()
    const [si, setSi] = React.useState(false)
    const [no, setNo] = React.useState(false)
    const [nombremarca, setNombreMarca] = React.useState('')
    const [numeroregistro, setNumeroRegistro] = React.useState('')
    const [tipomarca, setTipoMarca] = React.useState('')
    const [titularidad, setTitularidad] = React.useState('')
    const [productorautorizado, setProductorAutorizado] = React.useState('')
    const [maquiladorautorizado, setMaquiladorAutorizado] = React.useState('')
    const [agregarDatos, setAgregarDatos] = React.useState(false)
    const [detalleMarcas, setDetalleMarcas] = React.useState(false)
    let dataCliente = useSelector(store => store.FC_36Solicitud.cliente)
    const [editar, setEditar] = React.useState(false)
    let fc_36 = useSelector(store => store.FC_36Solicitud.fc_36)
    const [productoMap, setproductoMap] = React.useState()
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = [
        {
            field: 'marcaregistrada', headerName: 'Marca Registrada', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .3,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.marcaregistrada}`} arrow>
                        <label>{`${params.row.marcaregistrada} `}</label>
                    </Tooltip>
                </div>
            )
        },

        {
            field: 'nombremarca', headerName: 'Nombre de marca', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .5,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.nombremarca}`} arrow>
                        <label>{`${params.row.nombremarca} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numeroregistro', headerName: 'Número de registro o expediente', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .4,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numeroregistro}`} arrow>
                        <label>{`${params.row.numeroregistro} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'tipomarca', headerName: 'Tipo de marca', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .3,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.tipomarca == 1 ? 'Nominativa' : params.row.tipomarca == 2 ? 'Mixta' : 'Tridimencional'}`} arrow>
                        <label>{`${params.row.tipomarca == 1 ? 'Nominativa' : params.row.tipomarca == 2 ? 'Mixta' : 'Tridimencional'}    `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'titularidad', headerName: 'Titularidad de la marca', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .5,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.titularidad == '1' ? 'Propia (Título)' : params.row.titularidad == '2' ? 'Propia en trámite' :
                        params.row.titularidad == '3' ? 'Licencia de uso autorizado' : params.row.titularidad == '4' ? 'Cesión de derechos de marca autorizada' :
                            params.row.titularidad == '5' ? 'Licencia de uso en trámite' : params.row.titularidad == '6' ? 'Cesión de derechos de marca en trámite' : ''}`} arrow>
                        <label>{`${params.row.titularidad == '1' ? 'Propia (Título)' : params.row.titularidad == '2' ? 'Propia en trámite' :
                            params.row.titularidad == '3' ? 'Licencia de uso autorizado' : params.row.titularidad == '4' ? 'Cesión de derechos de marca autorizada' :
                                params.row.titularidad == '5' ? 'Licencia de uso en trámite' : params.row.titularidad == '6' ? 'Cesión de derechos de marca en trámite' : ''}`}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .4,
            renderCell: (params) => (
                <Fragment>
                    {params.row.baja === null ?
                        <Fragment>
                            {fc_36MarcasMap?.length > 0 ?
                                <Fragment>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                                </Fragment>
                                : <Fragment>
                                    <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                                    <button className={`btn btn-outline-secondary ms-1`} onClick={() => { setDataDetalle(params.row), setDetalleMarcas(true) }} >Detalle</button>
                                </Fragment>}
                        </Fragment>
                        : ((params.row.baja === false || params.row.baja === true) && params.row.isbaja === false) ?
                            <Fragment>
                                {/*<button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>*/}
                                <button className={params.row.baja === false ? `btn btn-outline-warning ms-1` : params.row.baja === true ? `btn btn-warning ms-1` : ''} onClick={() => { botonBaja(params) }} >Dar de Baja</button>
                                <button className={`btn btn-outline-secondary ms-1`} onClick={() => { setDataDetalle(params.row), setDetalleMarcas(true) }} >Detalle</button>
                            </Fragment> : ''
                        /*<Fragment>
                            {/*<button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                            <button className={(params.row.baja === false && params.row.alta === false) ? `btn btn-outline-warning ms-1` : (params.row.baja === false && params.row.alta === true) ? `btn btn-success ms-1` : ''} onClick={() => { botonAlta(params.row) }} >Dar de Alta</button>
                            <button className={`btn btn-outline-secondary ms-1`} onClick={() => { setDataDetalle(params.row), setDetalleMarcas(true) }} >Detalle</button>
                        </Fragment>*/
                    }
                </Fragment >

            )
        },
    ]

    const botonEliminar = async (params) => {
        handdleRemovePrev({ data: params.row })
    }
    const botonBaja = async (params) => {
        handdleMarcasBaja(params)
    }
    /*const botonAlta = async (params) => {
        handdleMarcasAlta(params)
    }*/
    const botonGuardar = async () => {
        let dato = {
            id: id, marcaregistrada: si === true ? 'Si' : no === true ? 'No' : '', nombremarca: nombremarca, numeroregistro: numeroregistro,
            tipomarca: tipomarca, titularidad: titularidad, productorautorizado: productorautorizado, maquiladorautorizado: maquiladorautorizado,
            baja: null, alta: true
        }
        handdleEditPrev(dato)
        setSi(false)
        setNo(false)
        setNombreMarca('')
        setNumeroRegistro('')
        setTipoMarca('')
        setTitularidad('')
        setProductorAutorizado('')
        setMaquiladorAutorizado('')
        setEditar(false)
        setAgregarDatos(false)
        setproductoMap([])
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setAgregarDatos(true)
        if (params.row.marcaregistrada === 'Si') setSi(true)
        else setNo(false)
        setNombreMarca(params.row.nombremarca)
        setNumeroRegistro(params.row.numeroregistro)
        setTipoMarca(params.row.tipomarca)
        setTitularidad(params.row.titularidad)
        setProductorAutorizado(params.row.productorautorizado)
        setMaquiladorAutorizado(params.row.maquiladorautorizado)
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(marcas)
    React.useEffect(() => {
        setRows(marcas)
    }, [marcas])

    const botonAgregar = async () => {
        if (!fc_36.productormezcal) {
            if (!fc_36.envasador) {
                if (agregarDatos) {
                    if (nombremarca.length > 0 && numeroregistro.length > 0 && titularidad != '0' && titularidad != '' && tipomarca != '0' && tipomarca != '',
                        productorautorizado.length > 0, maquiladorautorizado.length > 0) {
                        let dato = {
                            id: uuidv4(), marcaregistrada: si === true ? 'Si' : no === true ? 'No' : '', nombremarca: nombremarca, numeroregistro: numeroregistro,
                            tipomarca: tipomarca, titularidad: titularidad, productorautorizado: productorautorizado, maquiladorautorizado: maquiladorautorizado,
                            baja: null, alta: true
                        }
                        handdle(dato)
                        setSi(false)
                        setNo(false)
                        setNombreMarca('')
                        setNumeroRegistro('')
                        setTipoMarca('')
                        setTitularidad('')
                        setProductorAutorizado('')
                        setMaquiladorAutorizado('')
                        setAgregarDatos(false)

                    } else {
                        setvalidacion(true)
                    }
                } else {
                    setAgregarDatos(true)
                }
            } else {
                if (agregarDatos) {
                    if (nombremarca.length > 0 && numeroregistro.length > 0 && titularidad != '0' && titularidad != '' && tipomarca != '0' && tipomarca != '', productorautorizado.length > 0) {
                        let dato = {
                            id: uuidv4(), marcaregistrada: si === true ? 'Si' : no === true ? 'No' : '', nombremarca: nombremarca, numeroregistro: numeroregistro,
                            tipomarca: tipomarca, titularidad: titularidad, productorautorizado: productorautorizado, maquiladorautorizado: maquiladorautorizado,
                            baja: null, alta: true
                        }
                        handdle(dato)
                        setSi(false)
                        setNo(false)
                        setNombreMarca('')
                        setNumeroRegistro('')
                        setTipoMarca('')
                        setTitularidad('')
                        setProductorAutorizado('')
                        setMaquiladorAutorizado('')
                        setAgregarDatos(false)

                    } else {
                        setvalidacion(true)
                    }
                } else {
                    setAgregarDatos(true)
                }
            }

        } else {
            if (!fc_36.envasador) {
                if (agregarDatos) {
                    if (nombremarca.length > 0 && numeroregistro.length > 0 && titularidad != '0' && titularidad != '' && tipomarca != '0' && tipomarca != '',
                        maquiladorautorizado.length > 0) {
                        let dato = {
                            id: uuidv4(), marcaregistrada: si === true ? 'Si' : no === true ? 'No' : '', nombremarca: nombremarca, numeroregistro: numeroregistro,
                            tipomarca: tipomarca, titularidad: titularidad, productorautorizado: productorautorizado, maquiladorautorizado: maquiladorautorizado,
                            baja: null, alta: true
                        }
                        handdle(dato)
                        setSi(false)
                        setNo(false)
                        setNombreMarca('')
                        setNumeroRegistro('')
                        setTipoMarca('')
                        setTitularidad('')
                        setProductorAutorizado('')
                        setMaquiladorAutorizado('')
                        setAgregarDatos(false)

                    } else {
                        setvalidacion(true)
                    }
                } else {
                    setAgregarDatos(true)
                }
            } else {
                if (agregarDatos) {
                    if (nombremarca.length > 0 && numeroregistro.length > 0 && titularidad != '0' && titularidad != '' && tipomarca != '0' && tipomarca != '') {
                        let dato = {
                            id: uuidv4(), marcaregistrada: si === true ? 'Si' : no === true ? 'No' : '', nombremarca: nombremarca, numeroregistro: numeroregistro,
                            tipomarca: tipomarca, titularidad: titularidad, productorautorizado: productorautorizado, maquiladorautorizado: maquiladorautorizado,
                            baja: null, alta: true
                        }
                        handdle(dato)
                        setSi(false)
                        setNo(false)
                        setNombreMarca('')
                        setNumeroRegistro('')
                        setTipoMarca('')
                        setTitularidad('')
                        setProductorAutorizado('')
                        setMaquiladorAutorizado('')
                        setAgregarDatos(false)

                    } else {
                        setvalidacion(true)
                    }
                } else {
                    setAgregarDatos(true)
                }
            }
        }

    }
    const botonCancelar = async () => {
        setproductoMap([])
        setSi(false)
        setNo(false)
        setNombreMarca('')
        setNumeroRegistro('')
        setTipoMarca('')
        setTitularidad('')
        setProductorAutorizado('')
        setMaquiladorAutorizado('')
        setEditar(false)
        setAgregarDatos(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_36MarcasMap.filter(anexo => anexo?.idfc36_anexomarcas === params.row.idfc36_anexomarcas)
        setproductoMap(filtro[0])
        if (params.row.idfc36_anexomarcas) setId(params.row.idfc36_anexomarcas)
        else setId(params.row.idfc36_anexomarcas)
        setAgregarDatos(true)
        if (params.row.marcaregistrada === 'Si') setSi(true)
        else setNo(false)
        setNombreMarca(params.row.nombremarca)
        setNumeroRegistro(params.row.numeroregistro)
        setTipoMarca(params.row.tipomarca)
        setTitularidad(params.row.titularidad)
        setProductorAutorizado(params.row.productorautorizado)
        setMaquiladorAutorizado(params.row.maquiladorautorizado)
        setEditar(true)
    }
    const [dataDetalle, setDataDetalle] = React.useState([])
    const VerModalDetalle = (objeto) => {
        setDetalleMarcas(objeto)
    }

    return (
        <>
            <FormGroup>
                <div className='row align-items-center'>
                    {agregarDatos &&
                        <div className='col-md-12'>
                            <div className="form-floating mb-4">
                                <div className="input-group mb-3 text-center" >
                                    <label className="label-blanco" htmlFor="floatingInput">¿Su marca esta registrada ante el IMPI?</label>
                                    <input className={`ms-2 form-check-input ${productoMap ? 'inputValidado' : ''}`}
                                        type="checkbox" id="si" onChange={e => setSi(e.target.checked, setNo(!e.target.checked))}
                                        checked={si} />
                                    <label className="label-blanco ms-1" htmlFor="floatingInput">Si  </label>

                                    <label style={{ margin: 10 }}></label>
                                    <input className={`ms-2 form-check-input ${productoMap ? 'inputValidado' : ''}`}
                                        type="checkbox" id="no" onChange={e => setNo(e.target.checked, setSi(!e.target.checked))}
                                        checked={no} />
                                    <label className="label-blanco ms-1" htmlFor="floatingInput"> No</label>
                                </div>
                            </div>
                        </div>
                    }
                    {(si || no) &&
                        <Fragment>
                            <div className='col-md-4 mt-2'>
                                <div className="form-floating mb-3">
                                    <input type="texr" min='0' className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                        value={nombremarca} onChange={e => setNombreMarca(e.target.value)}
                                    />
                                    <label htmlFor='floatingInput'>Nombre de la marca</label>
                                    {nombremarca.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                    <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4 mt-2'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                        value={numeroregistro} onChange={e => setNumeroRegistro(e.target.value)}
                                    />
                                    {si === true ?
                                        (<label className="label-dark" htmlFor="floatingInput">Número de registro de marca</label>)
                                        : (<label className="label-dark" htmlFor="floatingInput"><small>Número de expediente de marca</small></label>)
                                    }
                                    {numeroregistro.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                                    <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-3">
                                    <select className={`form-select form-select-sm ${productoMap?.validacioncheck !== undefined ? (
                                        productoMap?.validacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                        value={tipomarca} onChange={e => setTipoMarca(e.target.value)} >
                                        <option value='0'>Tipo de marca</option>
                                        <option value='1'>Nominativa</option>
                                        <option value='2'>Mixta</option>
                                        <option value='3'>Tridimencional</option>
                                    </select>
                                    <br />
                                    <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                                </div>
                            </div>
                            {si &&
                                <div className='col-md-4'>
                                    <div className="form-floating mb-3">
                                        <select className={`form-select form-select-sm ${productoMap?.validacioncheck !== undefined ? (
                                            productoMap?.validacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                            value={titularidad} onChange={e => setTitularidad(e.target.value)} >
                                            <option value="0">Titularidad de la marca</option>
                                            <option value="1">Propia (Título)</option>
                                            <option value="3">Licencia de uso autorizado</option>
                                            <option value="4">Cesión de derechos de marca autorizada</option>
                                            <option value="5">Licencia de uso en trámite</option>
                                            <option value="6">Cesión de derechos de marca en trámite</option>
                                        </select>
                                        <br />
                                        <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                                    </div>
                                </div>
                            }
                            {no &&
                                <div className='col-md-4'>
                                    <div className="form-floating mb-3">
                                        <select className={`form-select form-select-sm ${productoMap?.validacioncheck !== undefined ? (
                                            productoMap?.validacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                            value={titularidad} onChange={e => setTitularidad(e.target.value)} >
                                            <option value="0">Titularidad de la marca</option>
                                            <option value="2">Propia en trámite</option>
                                            <option value="5">Licencia de uso en trámite</option>
                                            <option value="6">Cesión de derechos de marca en trámite</option>
                                        </select>
                                        <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                                    </div>
                                </div>
                            }

                            <div className='col-md-4 mt-2'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                        value={productorautorizado} onChange={e => setProductorAutorizado(e.target.value)}
                                    />
                                    <label className="label-dark" htmlFor="floatingInput">Productor autorizado</label>

                                    {
                                        (productorautorizado.length <= 0 && fc_36.productormezcal) ? <>
                                            <span className='text-danger'>Campo opcional</span><br /></> : ''
                                    }
                                    {
                                        (productorautorizado.length <= 0 && !fc_36.productormezcal) ? <>
                                            <span className='text-danger'>Campo obligatorio</span><br /></> : ''
                                    }
                                    {
                                        fc_36.productormezcal ? <>
                                            <span className='text-danger'>Si cuentas con otro productor autorizado captura su razon social aquí</span><br /><br /></> : ''
                                    }
                                    <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                                </div>
                            </div>

                            <div className='col-md-4 mt-2'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                        value={maquiladorautorizado} onChange={e => setMaquiladorAutorizado(e.target.value)}
                                    />
                                    <label className="label-dark" htmlFor="floatingInput">Maquilador autorizado</label>
                                    {
                                        (maquiladorautorizado.length <= 0 && fc_36.envasador) ? <>
                                            <span className='text-danger'>Campo opcional</span><br /></> : ''
                                    }
                                    {
                                        (maquiladorautorizado.length <= 0 && !fc_36.envasador) ? <>
                                            <span className='text-danger'>Campo obligatorio</span><br /></> : ''
                                    }
                                    {
                                        fc_36.envasador ? <>
                                            <span className='text-danger'>Si cuentas con otro maquilador autorizado captura su razon social aquí</span><br /><br /><br /></> : ''
                                    }
                                    <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                                </div>
                            </div>

                        </Fragment>
                    }
                </div>
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_36MarcasMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar marca</button>
                            </div>
                            <br />
                        </Fragment>) : ''}
                </Fragment> :
                <Fragment>
                    <div className='row'>
                        <div className='col-md-3'></div>
                        <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar marca</button>
                        <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                    </div> <br />
                </Fragment>
            } <br /> <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>

                <div className='col-12'><br />
                    <div style={{ height: (130 + (rows?.length * 50)), width: '103%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            //checkboxSelection={true}
                            //disableSelectionOnClick
                            /*onSelectionModelChange={(id) => {
                                idsParaAsignar = id
                            }}*/
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />

                    </div>
                    <span className='text-start'><b className='text-danger'>Nota:</b>Tilde el Botón DAR DE BAJA en cada una de las marcas a dar de baja.</span>
                    <br />
                </div>
            </div>
            {detalleMarcas && <ModalDetalleMarcas api={{ VerModalDetalle, dataDetalle, detalleMarcas }} />}

        </>
    )
}
export default TablaMarcas